import { useState } from "react";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const phone = "971507861818";
  const message = encodeURIComponent("Hello! I'm interested in your services. Please get in touch.");

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        bottom: 28,
        right: 28,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 10,
        background: "#25D366",
        borderRadius: hovered ? 50 : 50,
        padding: hovered ? "12px 20px 12px 14px" : "14px",
        boxShadow: hovered
          ? "0 8px 32px rgba(37,211,102,0.5)"
          : "0 4px 20px rgba(37,211,102,0.35)",
        textDecoration: "none",
        transition: "all 0.3s cubic-bezier(0.34,1.56,0.64,1)",
        transform: hovered ? "scale(1.08)" : "scale(1)",
        overflow: "hidden",
        maxWidth: hovered ? 220 : 56,
      }}
    >
      {/* WhatsApp SVG Icon */}
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="white"
        style={{ flexShrink: 0 }}
      >
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.425.638 4.7 1.751 6.676L2 30l7.52-1.726A13.93 13.93 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.842-1.605l-.418-.248-4.332.994.976-4.22-.272-.434A11.45 11.45 0 0 1 4.5 16C4.5 9.649 9.649 4.5 16 4.5S27.5 9.649 27.5 16 22.351 27.5 16 27.5zm6.29-8.598c-.345-.173-2.04-1.006-2.355-1.12-.315-.115-.544-.173-.773.173-.23.345-.888 1.12-1.088 1.35-.2.23-.4.259-.744.086-.345-.172-1.456-.537-2.773-1.711-1.025-.914-1.716-2.044-1.917-2.389-.2-.345-.021-.531.15-.703.155-.155.345-.403.518-.604.172-.2.229-.345.344-.575.115-.23.057-.432-.029-.604-.086-.172-.773-1.863-1.059-2.551-.278-.67-.562-.579-.773-.59l-.659-.011c-.23 0-.603.086-.918.432s-1.203 1.177-1.203 2.868 1.231 3.327 1.403 3.557c.172.23 2.423 3.7 5.872 5.19.821.354 1.462.566 1.961.724.824.262 1.574.225 2.167.136.661-.099 2.04-.834 2.327-1.638.287-.804.287-1.493.2-1.638-.086-.144-.315-.23-.66-.403z"/>
      </svg>

      {/* Label — only visible on hover */}
      <span style={{
        color: "#fff",
        fontFamily: "'Barlow', sans-serif",
        fontWeight: 700,
        fontSize: 14,
        whiteSpace: "nowrap",
        opacity: hovered ? 1 : 0,
        maxWidth: hovered ? 160 : 0,
        transition: "opacity 0.25s 0.05s, max-width 0.3s",
        overflow: "hidden",
      }}>
        Chat on WhatsApp
      </span>
    </a>
  );
}